"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManageUserModes = exports.GetHistoryRequestModes = exports.UserLargeFileUploadModes = exports.UserResourcesRequestModes = exports.SignUpByInvitationCodeRequestModes = exports.VisitDevices = exports.Filetype = exports.DataRenderTypes = exports.AccountCreationChannels = exports.SubscriptionManagementRequestModes = exports.QRFormats = exports.PaymentMethodsRequestModes = exports.SystemUserRoleTypes = exports.SystemUserTypes = void 0;
var SystemUserTypes;
(function (SystemUserTypes) {
    SystemUserTypes["USER"] = "user";
    SystemUserTypes["ADMIN"] = "admin";
    SystemUserTypes["SUB_USER"] = "subuser";
    SystemUserTypes["SUPERADMIN"] = "superadmin";
})(SystemUserTypes || (exports.SystemUserTypes = SystemUserTypes = {}));
var SystemUserRoleTypes;
(function (SystemUserRoleTypes) {
    SystemUserRoleTypes["OWNER"] = "owner";
    SystemUserRoleTypes["ADMIN"] = "admin";
    SystemUserRoleTypes["GUEST"] = "guest";
    SystemUserRoleTypes["MEMBER"] = "member";
})(SystemUserRoleTypes || (exports.SystemUserRoleTypes = SystemUserRoleTypes = {}));
var PaymentMethodsRequestModes;
(function (PaymentMethodsRequestModes) {
    PaymentMethodsRequestModes["SETUP"] = "setup";
    PaymentMethodsRequestModes["MANAGE"] = "manage";
    PaymentMethodsRequestModes["DEFAULT"] = "default";
})(PaymentMethodsRequestModes || (exports.PaymentMethodsRequestModes = PaymentMethodsRequestModes = {}));
var QRFormats;
(function (QRFormats) {
    QRFormats["SVG"] = "svg";
    QRFormats["JPG"] = "jpg";
    QRFormats["PNG"] = "png";
    QRFormats["WEBP"] = "webp";
})(QRFormats || (exports.QRFormats = QRFormats = {}));
var SubscriptionManagementRequestModes;
(function (SubscriptionManagementRequestModes) {
    SubscriptionManagementRequestModes["ENABLE_AUTORENEWAL"] = "enable-autorenewal";
    SubscriptionManagementRequestModes["DISABLE_AUTORENEWAL"] = "disable-autorenewal";
    SubscriptionManagementRequestModes["CHANGE_UPCOMING_SUBSCRIPTION"] = "change-upcoming-subscription";
    SubscriptionManagementRequestModes["SUBSCRIPTION_CHECKOUT_PREFLIGHT"] = "subscription-checkout-preflight";
    SubscriptionManagementRequestModes["CANCEL_SUBSCRIPTION_CHECKOUT_SUBSCRIPTION"] = "cancel-change-upcoming-subscription";
})(SubscriptionManagementRequestModes || (exports.SubscriptionManagementRequestModes = SubscriptionManagementRequestModes = {}));
var AccountCreationChannels;
(function (AccountCreationChannels) {
    AccountCreationChannels["EMAIL"] = "email";
    AccountCreationChannels["ADMIN"] = "admin";
    AccountCreationChannels["GOOGLE"] = "google";
    AccountCreationChannels["CHECKOUT"] = "checkout";
    AccountCreationChannels["FACEBOOK"] = "facebook";
    AccountCreationChannels["TEAMINVITE"] = "teaminvite";
})(AccountCreationChannels || (exports.AccountCreationChannels = AccountCreationChannels = {}));
var DataRenderTypes;
(function (DataRenderTypes) {
    DataRenderTypes["CSV"] = "csv";
    DataRenderTypes["SEND"] = "send";
    DataRenderTypes["TABULATE"] = "tabulate";
})(DataRenderTypes || (exports.DataRenderTypes = DataRenderTypes = {}));
var Filetype;
(function (Filetype) {
    Filetype["ZIP"] = "zip";
    Filetype["CSV"] = "csv";
})(Filetype || (exports.Filetype = Filetype = {}));
var VisitDevices;
(function (VisitDevices) {
    VisitDevices["BOT"] = "BOT";
    VisitDevices["MOBILE"] = "Mobile";
    VisitDevices["TABLET"] = "Tablet";
    VisitDevices["DESKTOP"] = "Desktop";
    VisitDevices["SMART_TV"] = "SmartTV";
})(VisitDevices || (exports.VisitDevices = VisitDevices = {}));
var SignUpByInvitationCodeRequestModes;
(function (SignUpByInvitationCodeRequestModes) {
    SignUpByInvitationCodeRequestModes["VERIFY"] = "verify";
    SignUpByInvitationCodeRequestModes["SIGNUP"] = "signup";
})(SignUpByInvitationCodeRequestModes || (exports.SignUpByInvitationCodeRequestModes = SignUpByInvitationCodeRequestModes = {}));
var UserResourcesRequestModes;
(function (UserResourcesRequestModes) {
    UserResourcesRequestModes["QRS"] = "qrs";
    UserResourcesRequestModes["POPUPS"] = "popups";
})(UserResourcesRequestModes || (exports.UserResourcesRequestModes = UserResourcesRequestModes = {}));
var UserLargeFileUploadModes;
(function (UserLargeFileUploadModes) {
    UserLargeFileUploadModes["CV"] = "cv";
    UserLargeFileUploadModes["MAIN"] = "main";
    UserLargeFileUploadModes["PUBLIC"] = "public";
    UserLargeFileUploadModes["QRCODES"] = "qrcodes";
    UserLargeFileUploadModes["RECEIPTS"] = "receipts";
    UserLargeFileUploadModes["QRASSETS"] = "qrAssets";
})(UserLargeFileUploadModes || (exports.UserLargeFileUploadModes = UserLargeFileUploadModes = {}));
var GetHistoryRequestModes;
(function (GetHistoryRequestModes) {
    GetHistoryRequestModes["INVOICES"] = "invoices";
    GetHistoryRequestModes["DOWNLOAD_INVOICES"] = "download-invoice";
})(GetHistoryRequestModes || (exports.GetHistoryRequestModes = GetHistoryRequestModes = {}));
var ManageUserModes;
(function (ManageUserModes) {
    ManageUserModes["SIGN_IN_LINK"] = "sign-in-link";
})(ManageUserModes || (exports.ManageUserModes = ManageUserModes = {}));
